// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1265":"5660e290","2098":"e2f6bca0","6023":"f4fa3383","6032":"6844e58b","6521":"a3b6e012","6657":"df16bc45","6897":"084c1cfc"}[chunkId] + ".chunk.css";
};